import { render, staticRenderFns } from "./send-code.vue?vue&type=template&id=b04baea6"
import script from "./send-code.vue?vue&type=script&lang=js"
export * from "./send-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports